module.exports = __webpack_public_path__ + "static/media/path0103.a357e44a.jpg";